export const TYPES = {
    LOADER:{
        START: "[LOADER] Start",
        ERROR: "[LOADER] Error",
        LOADED: "[LOADER] Complete",
    },

    AUTHENTICATION: {
      LOGIN: "[AUTHENTICATION] Login",
      LOGOUT: "[AUTHENTICATION] Logout",
    },
    
    DRAFT:{
      LOAD_DRAFT: "[DRAFT] Load Draft",

      ADD_FILE: "[DRAFT] Add file",
      CURRENT_PROGRESS: "[DRAFT] Progress",
  
      TITLE: "[DRAFT] Edit filename",
  
      SIGNERS: "[DRAFT] Edit signers",
      ADD_SIGNER: "[DRAFT] Add signer",
      EDIT_SIGNER: "[DRAFT] Edit signer",
      REMOVE_SIGNER: "[DRAFT] Remove signer",
  
      CAN_EDIT: "[DRAFT] Can Edit Fields",
      ADD_FIELD: "[DRAFT] Add field",
      MOVE_FIELD: "[DRAFT] Move field",
      RESIZE_FIELD: "[DRAFT] Resize field",
      REMOVE_FIELD: "[DRAFT] Remove field",
      EDIT_FIELD_DATE_FORMAT: "[DRAFT] Edit field date format",
  
      SUBJECT: "[DRAFT] Edit subject",
  
      CLEAN: "[DRAFT] Clean",
    },

    SIGNATURE: {
      LOAD_SIGNATURE: "[SIGNATURE] Load Signature",
      UPLOAD_SIGNATURE: "[SIGNATURE] Upload Signature",
      FOCUS_FIELD: "[SIGNATURE] Focus Field",
      EDIT_FIELDS: "[SIGNATURE] Edit fields",
      CLEAN: "[SIGNATURE] Clean",
    },

    FIELD_COLORS: {
      INITIAL_COLORS: "[FIELD_COLORS] Initial Colors",
      ADD_COLOR: "[FIELD_COLORS] Add Color",
      REMOVE_COLOR: "[FIELD_COLORS] Remove Color",
      CLEAN_COLORS: "[FIELD_COLORS] Clean Colors",
    }
};